import { footerLinks } from '@/mocks/homeData';

export default function Footer() {
  const scrollToSection = (href: string) => {
    const id = href.replace('#', '');
    const el = document.getElementById(id);
    if (el) {
      const offset = 80;
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <footer className="w-full bg-primary-900 text-background-100">
      <div className="container-content pt-16 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2.5 mb-4">
              <img
                src="/cleanup_icon.png"
                alt="CleanUp Naija Logo"
                className="h-8 w-8 object-contain shrink-0"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  target.parentElement!.querySelector('.footer-logo-fallback')!.classList.remove('hidden');
                }}
              />
              <div className="footer-logo-fallback hidden h-8 w-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 shrink-0">
                <i className="ri-sparkling-2-line text-lg" />
              </div>
              <span className="font-heading font-normal text-heading-sm text-background-50">
                CleanUp <span className="text-secondary-400 font-medium">Naija</span>
              </span>
            </div>
            <p className="text-body-sm text-background-300 max-w-xs leading-relaxed">
              Redefining professional cleaning and facility management across Nigeria. Cleaner homes, cleaner businesses, cleaner communities.
            </p>
            <div className="flex items-center gap-4 mt-6">
              {['instagram', 'twitter-x', 'linkedin'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-800 hover:bg-primary-700 transition-colors duration-200"
                >
                  <i className={`ri-${icon}-line text-sm text-background-200`} />
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          <div className="lg:col-span-2">
            <h4 className="font-heading font-semibold text-body-sm text-background-50 mb-4">Services</h4>
            <ul className="space-y-2.5">
              {footerLinks.services.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection(link.href);
                    }}
                    className="text-body-sm text-background-400 hover:text-secondary-400 transition-colors duration-200"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-heading font-semibold text-body-sm text-background-50 mb-4">Company</h4>
            <ul className="space-y-2.5">
              {footerLinks.company.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection(link.href);
                    }}
                    className="text-body-sm text-background-400 hover:text-secondary-400 transition-colors duration-200"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-heading font-semibold text-body-sm text-background-50 mb-4">Support</h4>
            <ul className="space-y-2.5">
              {footerLinks.support.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection(link.href);
                    }}
                    className="text-body-sm text-background-400 hover:text-secondary-400 transition-colors duration-200"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="lg:col-span-2">
            <h4 className="font-heading font-semibold text-body-sm text-background-50 mb-4">Get in Touch</h4>
            <div className="space-y-3">
              <p className="text-body-sm text-background-400">
                hello@cleanupnaija.com
              </p>
              <p className="text-body-sm text-background-400">
                +234 800 CLEAN UP
              </p>
              <p className="text-body-sm text-background-400">
                Lagos · Abuja · Port Harcourt
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-body-xs text-background-500">
            © {new Date().getFullYear()} CleanUp Naija. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" rel="nofollow" className="text-body-xs text-background-500 hover:text-background-300 transition-colors">Privacy</a>
            <a href="#" rel="nofollow" className="text-body-xs text-background-500 hover:text-background-300 transition-colors">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
}